var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 5.16667V6.83334M7.99967 5.16667V6.83334M11.333 17.6667L11.333 14.6227C11.333 14.4629 11.2191 14.3333 11.0785 14.3333H10.4997M14.3577 17.6667L15.4865 14.6243C15.5393 14.4821 15.427 14.3333 15.2669 14.3333H13.833M7.99967 10.1667H17.9997M12.208 21.8333H13.7913C17.1501 21.8333 18.8295 21.8333 19.8729 20.7053C20.9163 19.5773 20.9163 17.7617 20.9163 14.1306V13.7027C20.9163 10.0716 20.9163 8.25607 19.8729 7.12804C18.8295 6.00001 17.1501 6.00001 13.7913 6.00001H12.208C8.84925 6.00001 7.16987 6.00001 6.12644 7.12804C5.08301 8.25607 5.08301 10.0716 5.08301 13.7027V14.1306C5.08301 17.7617 5.08301 19.5773 6.12644 20.7053C7.16987 21.8333 8.84925 21.8333 12.208 21.8333Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalDropdown);
export default __webpack_public_path__ + "static/media/cal-dropdown.a4d34a3722416bed5e9c1288e4319773.svg";
export { ForwardRef as ReactComponent };